import React, { Component } from 'react';
import _ from 'lodash';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Table, Input, Button, Popconfirm, Tooltip } from 'antd';

function sum(arr) {
    if (!arr || arr.length === 0) return ''
    const total = arr.filter(e => !!e).reduce((prev, curr, idx, arr) => prev + curr, 0);
    return total.toFixed && total.toFixed(2)
}

const isEmpty = (val) => {
    return val === undefined || val === null;
}
class AmountItemsTable extends React.Component {
    constructor(props) {
        super(props);
    }

    // 计算合计项
    totalize = () => {
        const claimResps = _.cloneDeep(this.props.claimResps || []);
        const dataSource = _.flatten(claimResps.map((resp = {}, respIndex) => {
            let rowCount = 0;
            const { amountItems = [], claimResp = {} } = resp;
            rowCount = rowCount + amountItems.length
            return amountItems.map((item = {}, itemIndex) => {
                return {
                    'claimRespName': claimResp.claimRespName || '',
                    'amountName': item.amountItem && item.amountItem.itemName || '',
                    'exprDataFmt': item.formula && item.formula.exprDataFmt || '',
                    'lossAmount': !isEmpty(item.lossAmount) ? item.lossAmount.toFixed(2) : '',
                    'claimPercent': !isEmpty(resp.claimPercent) ? resp.claimPercent : '',
                    'claimAmount': !isEmpty(resp.claimAmount) ? resp.claimAmount.toFixed(2) : '',
                    'remark': resp.remark || '',
                    // 用于单元格列合并
                    rowSpan: itemIndex === 0 ? rowCount : 0,
                };
            })
        }))
        let newStatistics = {
            key: 'total',
            'claimRespName': '合计',
            rowSpan: 1,
        };
        if (dataSource.length) {
            const totalData = {};
            totalData['lossAmount'] =  sum(dataSource.map(item => +item['lossAmount']));
            totalData['claimAmount'] =  sum(claimResps.map(resp => +resp['claimAmount']));

            newStatistics = Object.assign(newStatistics, totalData)
        } 
        return [
            ...dataSource,
            newStatistics,
        ]
    }

    render() {
        const columns = [
            {
                title: '保障责任',
                dataIndex: 'claimRespName',
                key: 'claimRespName',
                render: (value, row) => {
    
                    return {
                        children: value,
                        props: {
                            rowSpan: row.rowSpan,
                        },
                    }
                }
            },
            {
                title: '费用项',
                dataIndex: 'amountName',
                key: 'amountName',
            },
            {
                title: '损失计算等式',
                dataIndex: 'exprDataFmt',
                key: 'exprDataFmt',
            },
            {
                title: '损失金额',
                dataIndex: 'lossAmount',
                key: 'lossAmount',
            },
            // {
            //     title: '赔付比例%',
            //     dataIndex: 'claimPercent',
            //     key: 'claimPercent',
            //     render: (value, row) => {
    
            //         return {
            //             children: value,
            //             props: {
            //                 rowSpan: row.rowSpan,
            //             },
            //         }
            //     }
            // },
            // {
            //     title: '赔偿金额',
            //     dataIndex: 'claimAmount',
            //     key: 'claimAmount',
            //     render: (value, row) => {
    
            //         return {
            //             children: value,
            //             props: {
            //                 rowSpan: row.rowSpan,
            //             },
            //         }
            //     }
            // },
            // {
            //     title: '备注',
            //     dataIndex: 'remark',
            //     key: 'remark',
            //     render: (value, row) => {
    
            //         return {
            //             children: <Tooltip placement="topLeft" title={value}>
            //                         <span>{value && value.substring(0, 8)}{value && value.length > 8 && '...'}</span>
            //                     </Tooltip>,
            //             props: {
            //                 rowSpan: row.rowSpan,
            //             },
            //         }
            //     }
            // },
        ];

        return (
            <div className='bill-table'>
                <h3 style={{ marginTop: 10, marginBottom: 10, fontSize: 12, fontWeight: 'bold' }}>损失项目</h3>
                <Table
                    size='small'
                    bordered
                    dataSource={this.totalize()}
                    columns={columns}
                    pagination={false}
                />

            </div>
        );
    }
}

export default AmountItemsTable